// extracted by mini-css-extract-plugin
export default {"wrapper":"versionHistoryButton__wrapper__BmxRd","update":"versionHistoryButton__update__pcoGe","button":"versionHistoryButton__button__OtURW"};